export const PROSPECT_PERMISSIONS = {
  GET_SCORE: 'prospect:GetScore',
  LIST_SCORES: 'prospect:ListScores',
  CREATE_SCORE: 'prospect:CreateScore',
} as const;
